import React from 'react';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/TaskTemplates/Columns';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

interface Props extends IDataGrid {}

export const TaskTemplatesDatagrid = ({ data, handleDelete, handleEdit }: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'TaskTemplates.List';

  const columns = Columns(handleDelete, handleEdit, translate);

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'before',
      html: translate!('Task templates', transFormName),
    });
  };

  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={columns}
        exportName="task-templates"
        onToolbarPreparing={onToolbarPreparing}
        enableXlsxExport
        columnChooser
        allowColumnResizing
        allowColumnReordering
        allowHeaderFiltering
        pageSizeChangeVisible
        onCellDblClick={(e) => handleEdit && handleEdit(e)}
      />
    </>
  );
};
